import React from "react";
import "./node.css";

class Node extends React.Component {
  constructor(props) {
    super(props);
    this.row = props.row;
    this.col = props.col;
    this.state = { type: props.type };
  }

  getExtraClassName = () => {
    const extraClassName =
      this.state.type === "finish"
        ? "node-finish"
        : this.state.type === "start"
        ? "node-start"
        : this.state.type === "obstacle"
        ? "node-obstacle"
        : "";
    return extraClassName;
  };

  clearObstacle = () => {
    if (this.state.type === "obstacle") this.setState({ type: "regular" });
  };

  toggleObstacle = () => {
    if (this.state.type === "regular") this.setState({ type: "obstacle" });
    else if (this.state.type === "obstacle") this.setState({ type: "regular" });
  };

  render() {
    return (
      <div
        id={`node-${this.row}-${this.col}`}
        className={`node ${this.getExtraClassName()}`}
        onPointerDown={(e) => {
          e.preventDefault();
          e.currentTarget.releasePointerCapture(e.pointerId);
          this.props.onMouseDown(this.row, this.col);
        }}
        onPointerEnter={(e) => {
          // Only respond if the pointer is down (e.g., during drag)
          if (e.buttons === 1) {
            this.props.onMouseEnter(this.row, this.col);
          }
        }}
        onPointerUp={(e) => {
          e.preventDefault();
          this.props.onMouseUp();
        }}
      >
        {/* {`${this.row}-${this.col}`} */}
      </div>
    );
  }
}

export default Node;
